import _get from 'lodash/get';
import _kebabCase from 'lodash/kebabCase';

import { Google, GoogleTransformers, Pixall } from 'reaxl-analytics-handlers';

import { getInventoryOwnerById, isVDP } from '@/analytics/utilities';

const { inventoryTransformer: googleInventoryTransformer } = GoogleTransformers;

/**
 * @summary Sends Pixall and Google event when clicking View similar vehicles Button
 * @events cmp
 */
export function searchLinkClick(metadata, option) {
    const {
        data = {},
        dataLayer = {},
        state,
        event,
    } = metadata;

    const currentPageName = _get(state, 'currentPageName', '');
    const label = event.target.innerText || event.target.textContent || '';
    const { inventoryId } = data;
    const inheritPageData = !['vdp'].includes(currentPageName);
    const inventory = getInventoryOwnerById(state, inventoryId);
    const isPrivateSeller = inventory?.owner?.privateSeller;
    const listingType = _get(inventory, 'listingType', '').toLowerCase();
    const linkCopy = _kebabCase(label);
    const vehicleData = googleInventoryTransformer(inventory, { target: 'vehicle', dataLayer }, inheritPageData);

    const cmp = `text-link::srp::${linkCopy}::nba`;

    Google.sendClickEvent({
        eventElement: `${currentPageName}_${listingType}`,
        eventResult: cmp,
        eventData: {
            vehicle: vehicleData,
        },
    }, option);

    Pixall.sendClickEvent({
        eventSource: 'link',
        inventory,
        label: cmp,
        ...(isVDP(dataLayer) && { pixallData: { clickTypeToListingType: !isPrivateSeller } }),
        ...(isPrivateSeller && {
            listingType: 'pvt',
            pageId: 'fyc_psx_vdp',
        }),
    }, dataLayer, option);

    // return data for custom event
    return { cmp };
}
